const INITIAL = {}

export default function projectionInfo(state = INITIAL, action) {
  switch (action.type) {
    case "SET_PROJECTION_DATA":
      return (
        {
          action: "EDIT",
          data: action.data 
        }
      )
      case "CREATE_PROJECTION_DATA":
        return (
          {
            action: "CREATE",
            data: {}
          }
        )
    default:
      return state;
  }
}